module.exports = __webpack_public_path__ + "static/media/activeIcon.e2a5e7ef.svg";